<template>
    <div class="success-toast">
        <img src="@/assets/images/icons/toast-success.svg" />
        <div class="success-toast__wrapper">
            <h2 class="success-toast__title">{{ title }}</h2>
            <span v-if="description" class="success-toast__description">{{ description }}</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SuccessToast',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.success-toast {
    display: flex;
    align-items: flex-start;
    gap: 8px;

    &__title {
        color: #111724;
        font-family: "GT Walsheim Pro";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
    }

    &__description {
        color: #111724;
        font-family: "GT Walsheim Pro";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
    }

    &__wrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
}
</style>
